module.exports = __webpack_public_path__ + "img/kombarov.6e65849d.jpg";